import { combineObjectWithoutCloning } from "@helpers/_functions";

export const calendarData = {
  initialState: {
    //calendar view
    viewCalendar: "month",
    // Heures travaillées
    workingHoursEnterpriseData: [],
    dateIndexWorkingHoursEnterpriseData: [],
    // Mon horaire
    horaryEmployerWithLunchMonthData: [],
    horaryEmployerWithoutLunchMonthData: [],
    indexLoadingMonHoraire: [],
    myScheduleCacheKey: null,
    myScheduleVersion: 0,
    myScheduleDayOffVersion: 0,
    myScheduleAbsences: {},
    myTeamSchedule: { scopeKey: null, version: 0, months: {} },
    // Planification
    horaryEnterpriseWithLunchMonthData: [],
    horaryEnterpriseWithoutLunchMonthData: [],
    indexLoadingPlanification: [],
    monthsConges: []
  },
  handlers: {
    SET_CALENDAR_VIEW: (state, payload) =>
      combineObjectWithoutCloning(state, { viewCalendar: payload }),
    WORKING_HOUR_ENTERPRISE_DATA: (state, payload) =>
      combineObjectWithoutCloning(state, {
        workingHoursEnterpriseData: payload
      }),
    DATE_INDEX_WORKIN_HOUR_ENTERPRISE_DATA: (state, payload) =>
      combineObjectWithoutCloning(state, {
        dateIndexWorkingHoursEnterpriseData: payload
      }),
    HORARY_EMPLOYER_WITH_LUNCH_MONTH_DATA: (state, payload) =>
      combineObjectWithoutCloning(state, {
        horaryEmployerWithLunchMonthData: payload
      }),
    HORARY_EMPLOYER_WITHOUT_LUNCH_MONTH_DATA: (state, payload) =>
      combineObjectWithoutCloning(state, {
        horaryEmployerWithoutLunchMonthData: payload
      }),
    INDEX_LOADING_MON_HORAIRE: (state, payload) =>
      combineObjectWithoutCloning(state, {
        indexLoadingMonHoraire: payload,
        ...(payload.length
          ? {}
          : {
              horaryEmployerWithLunchMonthData: [],
              horaryEmployerWithoutLunchMonthData: [],
              myScheduleAbsences: {}
            }),
        myScheduleVersion: state.myScheduleVersion + (payload.length ? 0 : 1)
      }),
    SET_PERSONAL_SCHEDULE_SCOPE: (state, cacheKey) =>
      state.myScheduleCacheKey === cacheKey
        ? state
        : {
            ...state,
            myScheduleCacheKey: cacheKey,
            myScheduleVersion: state.myScheduleVersion + 1,
            horaryEmployerWithLunchMonthData: [],
            horaryEmployerWithoutLunchMonthData: [],
            indexLoadingMonHoraire: [],
            myScheduleAbsences: {}
          },
    SET_PERSONAL_SCHEDULE_MONTH: (state, payload) =>
      state.myScheduleCacheKey !== payload.cacheKey ||
      state.myScheduleVersion !== payload.version
        ? state
        : {
            ...state,
            horaryEmployerWithLunchMonthData: payload.hoursWithLunch,
            horaryEmployerWithoutLunchMonthData: payload.hoursWithoutLunch,
            myScheduleAbsences: Array.isArray(payload.calendarAbsences)
              ? {
                  ...state.myScheduleAbsences,
                  [payload.month]: payload.calendarAbsences
                }
              : state.myScheduleAbsences,
            indexLoadingMonHoraire: [
              ...new Set([...state.indexLoadingMonHoraire, payload.month])
            ]
          },
    SET_MY_TEAM_SCHEDULE_SCOPE: (state, scopeKey) =>
      state.myTeamSchedule.scopeKey === scopeKey
        ? state
        : {
            ...state,
            myTeamSchedule: {
              scopeKey,
              version: state.myTeamSchedule.version + 1,
              months: {}
            }
          },
    INVALIDATE_MY_SCHEDULE_LEAVES: (state) => ({
      ...state,
      horaryEmployerWithLunchMonthData: [],
      horaryEmployerWithoutLunchMonthData: [],
      indexLoadingMonHoraire: [],
      myScheduleAbsences: {},
      myScheduleVersion: state.myScheduleVersion + 1,
      myTeamSchedule: {
        ...state.myTeamSchedule,
        version: state.myTeamSchedule.version + 1,
        months: {}
      }
    }),
    INVALIDATE_MY_TEAM_SCHEDULE: (state, payload) => ({
      ...state,
      myScheduleDayOffVersion:
        state.myScheduleDayOffVersion + (payload?.daysOff ? 1 : 0),
      myTeamSchedule: {
        ...state.myTeamSchedule,
        version: state.myTeamSchedule.version + 1,
        months: {}
      }
    }),
    SET_MY_TEAM_SCHEDULE_MONTH: (state, payload) =>
      state.myTeamSchedule.scopeKey !== payload.scopeKey ||
      state.myTeamSchedule.version !== payload.version
        ? state
        : {
            ...state,
            myTeamSchedule: {
              ...state.myTeamSchedule,
              months: {
                ...state.myTeamSchedule.months,
                [payload.month]: payload.data
              }
            }
          },
    HORARY_ENTERPRISE_WITH_LUNCH_MONTH_DATA: (state, payload) =>
      combineObjectWithoutCloning(state, {
        horaryEnterpriseWithLunchMonthData: payload
      }),
    HORARY_ENTERPRISE_WITHOUT_LUNCH_MONTH_DATA: (state, payload) =>
      combineObjectWithoutCloning(state, {
        horaryEnterpriseWithoutLunchMonthData: payload
      }),
    INDEX_LOADING_PLANIFICATION: (state, payload) =>
      combineObjectWithoutCloning(state, {
        indexLoadingPlanification: payload
      }),
    SET_MONTHS_CONGES: (state, payload) =>
      combineObjectWithoutCloning(state, {
        monthsConges: payload
      }),
    INVALIDATE_PLANNING_TIMEZONE: (state) => ({
      ...state,
      horaryEnterpriseWithLunchMonthData: [],
      horaryEnterpriseWithoutLunchMonthData: [],
      indexLoadingPlanification: [],
      monthsConges: []
    }),
    RESET_CALENDAR_DATA: () => calendarData.initialState,
    RESET_ALL: () => calendarData.initialState
  }
};

export default calendarData;
